"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ad_hok_1 = require("ad-hok");
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var cleanupProps_1 = __importDefault(require("./cleanupProps"));
var refName = '_addPropIdentityStabilization-ref';
var equalRefName = '_addPropIdentityStabilization-equalRef';
var addPropIdentityStabilization = function (propName) {
    return ad_hok_1.flowMax(ad_hok_1.addRef(refName, function (_a) {
        var _b = propName, propValue = _a[_b];
        return propValue;
    }), ad_hok_1.addRef(equalRefName, function (_a) {
        var _b = propName, propValue = _a[_b];
        return propValue;
    }), ad_hok_1.addProps(function (_a) {
        var _b, _c, _d, _e;
        var _f = refName, ref = _a[_f], _g = propName, propValue = _a[_g], _h = equalRefName, equalRef = _a[_h];
        var previousValue = ref.current;
        var previousEqualValue = equalRef.current;
        if (previousValue === propValue)
            return _b = {}, _b[propName] = previousValue, _b;
        if (previousEqualValue === propValue)
            return _c = {}, _c[propName] = previousValue, _c;
        if (lodash_isequal_1.default(previousValue, propValue)) {
            equalRef.current = propValue;
            return _d = {}, _d[propName] = previousValue, _d;
        }
        ref.current = propValue;
        return _e = {}, _e[propName] = propValue, _e;
    }), cleanupProps_1.default([refName, equalRefName]));
};
exports.default = addPropIdentityStabilization;
